import { Chapter } from '@core/types';
import { useTranslation } from 'react-i18next';
import { ChaptersContainer } from '../../molecules';
import { ChaptersNavigatorContainer } from '../../molecules/ChaptersNavigatorContainer';
import { ChaptersNavigatorTitle } from '../../molecules/ChaptersNavigatorTitle';

export const Chapters = ({
    chapters,
    activeChapter,
    showHeader,
    onChapterClick
}: {
    chapters: Chapter[];
    activeChapter: Chapter | null | undefined;
    showHeader: boolean;
    onChapterClick?: (chapter: Chapter) => void;
}) => {
    const { t } = useTranslation();

    return (
        <ChaptersNavigatorContainer>
            <ChaptersNavigatorTitle showHeader={showHeader}>{t('Player.Chapters.Heading')}</ChaptersNavigatorTitle>
            <ChaptersContainer chapters={chapters} activeChapter={activeChapter} onChapterClick={onChapterClick} />
        </ChaptersNavigatorContainer>
    );
};
